import { jsx as r, Fragment as x } from "react/jsx-runtime";
import "react";
import { classes as c } from "../../utils/helpers.js";
import '../../assets/GradientButton.css';const a = {
  "gradient-btn": "_gradient-btn_a5mxg_1",
  "gradient-btn--small": "_gradient-btn--small_a5mxg_23",
  "gradient-btn--large": "_gradient-btn--large_a5mxg_30",
  "gradient-btn--primary": "_gradient-btn--primary_a5mxg_37",
  "gradient-btn--action": "_gradient-btn--action_a5mxg_41",
  "gradient-btn--info": "_gradient-btn--info_a5mxg_45",
  "gradient-btn--danger": "_gradient-btn--danger_a5mxg_49"
};
function o({
  type: l = "button",
  label: i = "",
  onClick: $ = () => {
  },
  varient: e = "primary",
  size: g = "regular",
  classname: d = "",
  href: _ = "",
  gradientStartColor: n = "",
  gradientEndColor: t = "",
  hoverGradientStartColor: p = "",
  hoverGradientEndColor: u = "",
  ...b
}) {
  const m = e === "" ? "" : `gradient-btn--${e}`, s = g === "" ? "" : `gradient-btn--${g}`;
  return /* @__PURE__ */ r(x, { children: _ === "" ? /* @__PURE__ */ r(
    "button",
    {
      type: l,
      onClick: $,
      className: c([
        d,
        a["gradient-btn"],
        "gradient-btn",
        e === "" ? "" : a[m],
        g === "" ? "" : a[s]
      ]),
      style: n !== "" && t !== "" ? {
        "--gradient": `linear-gradient(180deg, ${t}, ${n}, ${n},${t})`
      } : {},
      ...b,
      children: i
    }
  ) : /* @__PURE__ */ r(
    "a",
    {
      href: _,
      className: c([
        d,
        a["gradient-btn"],
        "gradient-btn",
        e === "" ? "" : a[m],
        g === "" ? "" : a[s]
      ]),
      style: n !== "" && t !== "" ? {
        "--gradient": `linear-gradient(180deg, ${t}, ${n}, ${n},${t})`
      } : {},
      ...b,
      children: i
    }
  ) });
}
export {
  o as GradientButton,
  o as default
};
